// Angular Import
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild, Renderer2
} from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { CmsService } from '../../../services/cms.service';
// React Imports
import { BehaviorSubject, Subscription } from 'rxjs';
import { DealsModel } from 'src/app/models/main/deals/deals.model';
import { DealsService } from 'src/app/services/deals.service';
import { SearchModel } from 'src/app/models/main/deals/search.model';

@Component({
    selector: 'app-build-itinerary',
    templateUrl: './build-itinerary.component.html',
    styleUrls: ['./build-itinerary.component.scss'],
    standalone: false
})
export class BuildItineraryComponent implements OnInit, OnDestroy {
  public title: string;
  locationsArray: DealsModel[] = [];
  Search: SearchModel = new SearchModel();
  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private data: DealsService,
    private renderer:Renderer2
  ) {}

  public ngOnInit() : void {

  }

  
  search()
  {

  }

  
  public ngOnDestroy() : void {
   
  }
}
  
